<template>
  <div id="app">
    <v-app id="inspire">
      <v-main class="bg">
        <div class="container pa-0 border border-dark bg-white">

          <TopHeader></TopHeader>

          <div class="container">
            <section class="text-center my-5">
              <!-- <h2 class="h1-responsive font-weight-bold my-5">{{$route.name}}</h2> -->
              <router-view></router-view>
            </section>
          </div>

          <Footer></Footer>
        </div>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader';
import Footer from '@/components/Footer';

export default {
  name: 'app',
  components: {
    TopHeader,
    Footer,
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  created() {
    this.$store.dispatch('requestCategories');
  },
}
</script>

<style>
.bg {
  background: url('assets/img/bg-3.jpg') no-repeat center center fixed;
  background-size: cover;
}

#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue